import React from 'react';
import styled from 'styled-components';

import enter from '../../../svg/enter.svg';

const Element = styled.div`
  background-color: var(--color-gunmetal);
  font-family: BrandonGrotesque-Regular;
  font-size: 14px;
  padding: 5px;
  border-radius: 5px;
  color: #ffffff;
  margin-right: 13px;
  cursor: pointer;
  white-space: nowrap;
  margin-bottom: 8px;
  display: inline-block;
  letter-spacing: 0.5px;
`;

interface Props {
  value: Array<string>;
  onChange: Function;
}

interface State {
  current: string;
  value: Array<string>;
}

class MultiInput extends React.Component<Props, State> {
  constructor(props) {
    super(props);
    this.state = { current: '', value: this.props.value || [] };
  }

  addAccount() {
    if (this.state.current === '') return;
    if (this.state.value.includes(this.state.current)) {
      this.setState({ current: '' });
      return;
    }

    const result =
      this.state.current[0] === '@' || this.state.current[0] === '#'
        ? this.state.current.substring(1)
        : this.state.current;
    const novi = [...this.state.value, result];
    this.setState({ current: '', value: novi });
    this.props.onChange(novi);
  }

  removeAccount(i) {
    const accounts = this.state.value.filter((item) => item !== this.state.value[i]);
    this.setState({ value: accounts });
    this.props.onChange(accounts);
  }

  render() {
    return (
      <div style={{display: 'flex', flexWrap: 'wrap', flexDirection: 'column'}}>

        <div style={{display: 'flex', alignItems: 'center'}}>
          <input
            value={this.state.current}
            onChange={(evt) => this.setState({ current: evt.target.value })}
            onKeyPress={(e) => (!e || (e && e.key === 'Enter') ? this.addAccount() : '')}
          />

          <img
            src={enter}
            onClick={() => this.addAccount()}
            alt="Add social handle"
            style={{ cursor: 'pointer', marginLeft: '10px' }}
          />
        </div>

        <div style={{display: 'block', marginTop: '10px'}}>
          {this.state.value.map((item, i) => [
            <Element key={i} onClick={() => this.removeAccount(i)}>[x] {item}</Element>,
            ' ',
          ])}
        </div>
      </div>
    );
  }
}
export default MultiInput;
